import { render, staticRenderFns } from "./TdContactsInfo.vue?vue&type=template&id=4c6d3b76"
import script from "./TdContactsInfo.vue?vue&type=script&lang=js"
export * from "./TdContactsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports